import { defaultEnvironmentConfigs } from './environment.defaults';

export const environment = {
  ...defaultEnvironmentConfigs,
  ssoEnv: 'PROD',
  sessionTokenName: 'iotDeviceManagementApi_PROD',
  sessionRefreshTokenName: 'iotDeviceManagementApi_RT_PROD',
  apiUrl: '/',
  ssoUrl: 'https://devices.scm3d.com',
  appInsights: {
    instrumentationKey: 'b333e547-acc9-4ca1-ad70-610a395e32eb',
    cloudRole: 'df-iot-device-management-portal',
  },
};
